import * as stylex from '@stylexjs/stylex'
import { useEffect } from 'react'

import Icon from './Icon'


const styles = stylex.create({
  s0: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 110,
    display: "flex",
    maxWidth: "calc(100vw-2.5rem)",
    alignItems: "center",
    gap: "12px",
    borderRadius: "0.75rem",
    borderWidth: 1,
    borderColor: "#cfe0cf",
    backgroundColor: "#f8fcf7",
    paddingInline: "16px",
    paddingBlock: "12px",
    fontSize: "13px",
    fontWeight: 500,
    color: "#315c3b",
    boxShadow: "0 12px 30px rgba(36,61,40,.16)",
  },
  s1: {
    display: "flex",
    height: "24px",
    width: "24px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "9999px",
    backgroundColor: "#4d9562",
    color: "#fff",
  },
  s2: {
    height: "16px",
    width: "16px",
  },
  s3: {
    marginLeft: "4px",
    borderRadius: "0.25rem",
    padding: "4px",
    color: "#54705b",
    ":hover": {
      backgroundColor: "#eaf3e8",
    },
  },
})
type ToastProps = {
  message: string
  onDismiss: () => void
}

export default function Toast({ message, onDismiss }: ToastProps) {
  useEffect(() => {
    const timeout = window.setTimeout(onDismiss, 4200)
    return () => window.clearTimeout(timeout)
  }, [onDismiss])

  return (
    <div aria-live="polite" {...stylex.props(styles.s0)}>
      <span {...stylex.props(styles.s1)}><Icon {...stylex.props(styles.s2)} name="check" /></span>
      <span>{message}</span>
      <button aria-label="Dismiss notification" {...stylex.props(styles.s3)} onClick={onDismiss} type="button"><Icon {...stylex.props(styles.s2)} name="close" /></button>
    </div>
  )
}
